__turbopack_context__.v({
  "center": "grid-column-module-scss-module__L-_Z_W__center",
  "gridColumn": "grid-column-module-scss-module__L-_Z_W__gridColumn",
});
